import React from 'react';
import { ReactComponent as ErrorBadge } from '../resources/images/no-page-error.svg';
import { FullScreenButtonPage } from './FullScreenButtonPage';
import { makeStyles, Typography } from '@material-ui/core';
import { PATH_HOME } from '../containers/RoutePaths';
import { getValue } from '../styles/stylesSelector';
import clsx from 'clsx';

export const useBigHeaderTextStyles = makeStyles(theme => ({
    marginTop: {
        marginTop: theme.spacing(1.5),
    },
    colorVariant: {
        color: theme.palette.primary.main,
    },
    boldHeaderText: {
        fontWeight: 700,
    },
}));

const SubtitleText = () => {
    const classes = useBigHeaderTextStyles();

    return (
        <>
            <Typography className={classes.boldHeaderText} variant="h1">
                Woah,
            </Typography>
            <Typography variant="h1" className={clsx(classes.boldHeaderText, classes.marginTop)}>
                This Page
            </Typography>
            <Typography className={clsx(classes.boldHeaderText, classes.marginTop)} variant="h1">
                Doesn't{' '}
                <Typography component="span" variant="h1" className={clsx(classes.boldHeaderText, classes.colorVariant)}>
                    Exist
                </Typography>
                .
            </Typography>
        </>
    );
};
export default function LoadingErrorPage({ loginNotRequired }) {
    return (
        <FullScreenButtonPage
            isLoginRequired={!loginNotRequired}
            Icon={ErrorBadge}
            SubtitleText={SubtitleText}
            bodyText={'Please check the url or click below to return to the homepage.'}
            buttonText={'Back to Home'}
            onButtonClick={() => (window.location = PATH_HOME)}
            showShadow={getValue({
                ned: false,
                watchman: true,
            })}
        />
    );
}
